import React, { useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import {
  notification,
  Dropdown,
  Tooltip
} from 'antd';

import {
  isTicketOpen
} from '../../../../actions';
import Icon from '../../atoms/global/Icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { showTaskAsModal } from '../../../../actions/toggleAction';
import { clearOpenedTaskId, editTaskAction, toggleTaskWatch } from '../../../../redux/tasks/actions';

import { FormattedMessage, useIntl } from 'react-intl';
import { DeleteRowOutlined, SwitcherOutlined } from '@ant-design/icons';
import { toggleDuplicateTaskModal } from '../../../../actions/modalAction';
import { getOpenedTask, getTaskProjectIdListSelector, isOpenedTaskLoading, isTaskCreator } from '../../../../redux/tasks/taskEntities/selectors';
import { Skeleton } from '@mui/material';
import { hasDeleteTaskRightsBasedOnRoleSelector } from '../../../../redux/dashboards/selectors';
import { isWorkfloSuperAdminSelector } from '../../../../redux/user/selectors';
import { isCurrentWorkspaceOwnerOrAdmin } from '../../../../redux/general/selectors';
import { isEmpty } from 'lodash';

const TaskNavSection = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    task,
    setDeleteModalOpen,
    isModal = false,
    isTaskLoading,
    setIsModalView,
    setSelectedTab,
    setSubTask,
    setShowParentTaskSearch,
    hasDeleteTaskRightsBasedOnRole,
    isTaskCreator,
    isWorkfloSuperAdmin,
    isWorkspaceOwnerAdmin,
  } = props;

  const isComplete = task?.isCompleted;

  const { user, role } = useSelector((state) => state.userReducer);
  const userId = user?._id;
  const navigate = useNavigate();

  const isGuest = role == 'guest';
  const hasTaskDeleteRights = useMemo(
    () => hasDeleteTaskRightsBasedOnRole || isTaskCreator, // || isWorkspaceOwnerAdmin || isWorkfloSuperAdmin,
    [
      hasDeleteTaskRightsBasedOnRole,
      isTaskCreator,
      // isWorkfloSuperAdmin,
      // isWorkspaceOwnerAdmin,
    ],
  );

  const workspaceId = sessionStorage.getItem("workspaceId");

  const closeTicket = () => {
    dispatch(isTicketOpen(false));
    const params = new URLSearchParams(location.search);
    params.delete('selectedTask'); // Remove the specified parameter

    // Construct the new URL with updated parameters
    const newUrl = `${location.pathname}?${params.toString()}`;

    // Use navigate to replace the current URL
    navigate(newUrl);
    dispatch(clearOpenedTaskId());
  };


  const collaboratorsIds = task?.participants && task?.participants.map((member) => member._id);
  const isMuted = task?.participants?.find(member => member?._id == userId)?.isMuted

  const mi = 'flex items-center gap-3 px-3 py-2 rounded-lg text-[13px] font-medium cursor-pointer';

  const items = [
    {
      key: '2',
      label: (
        <div className={mi} style={{ color: 'rgba(15,15,25,0.72)' }} onClick={() => dispatch(toggleDuplicateTaskModal(true, task))}>
          <Icon name='project-task.svg' height='15px' />
          <FormattedMessage id="DUPLICATE_TASK" defaultMessage="Duplicate Task" />
        </div>
      ),
    },
    {
      key: '3',
      label: (
        <div className={mi} style={{ color: 'rgba(15,15,25,0.72)' }} onClick={() => { dispatch(showTaskAsModal(!isModal)); setIsModalView(!isModal); }}>
          <Icon name='double-arrow.svg' height='15px' />
          {isModal ? <FormattedMessage id="OPEN_SIDE_PANEL" defaultMessage="Open Side Panel" /> : <FormattedMessage id="OPEN_FULLSCREEN" defaultMessage="Open Fullscreen" />}
        </div>
      ),
    },
    !task?.parentTaskId && {
      key: '6',
      label: (
        <div className={mi} style={{ color: 'rgba(15,15,25,0.72)' }} onClick={() => { setShowParentTaskSearch(true); setSubTask(task); }}>
          <img src="/images/icons/subtask-arrow.svg" className="size-4 opacity-55" style={{ filter: 'brightness(0) saturate(80%)' }} />
          <FormattedMessage id="CONVERT_TO_SUBTASK" defaultMessage="Convert to Subtask" />
        </div>
      ),
    },
    task?.parentTaskId && {
      key: '7',
      label: (
        <div className={mi} style={{ color: 'rgba(15,15,25,0.72)' }} onClick={() => dispatch(editTaskAction({ _id: task._id, parentTaskId: null, parentTask: null }))}>
          <DeleteRowOutlined style={{ fontSize: '15px', opacity: 0.55 }} />
          <FormattedMessage id="REMOVE_AS_SUBTASK" defaultMessage="Remove as Subtask" />
        </div>
      ),
    },
    task?.parentTaskId && {
      key: '8',
      label: (
        <div className={mi} style={{ color: 'rgba(15,15,25,0.72)' }} onClick={() => { setShowParentTaskSearch(true); setSubTask(task); }}>
          <SwitcherOutlined style={{ fontSize: '15px', opacity: 0.55 }} />
          <FormattedMessage id="CHANGE_PARENT_TASK" defaultMessage="Change parent task" />
        </div>
      ),
    },
    hasTaskDeleteRights && { type: 'divider' },
    hasTaskDeleteRights && {
      key: '5',
      label: (
        <div className={mi} style={{ color: '#ef4444' }} onClick={() => setDeleteModalOpen(true)}>
          <Icon name='delete-red.svg' height='15px' />
          <FormattedMessage id="DELETE_TASK" defaultMessage="Delete Task" />
        </div>
      ),
    },
  ];

  return (
    <div className='user-panel'>
      <div className='d-flex justify-content-between' style={{ padding: isModal ? '14px 20px' : '12px 14px', borderBottom: '1px solid rgba(99,102,241,0.1)', background: '#ffffff' }}>
        <div className='d-flex align-center gap-3'>
          <div
            className='opened-task-title-identifier text-[12px] font-mono font-semibold px-2 rounded-md'
            style={{ color: 'rgba(99,102,241,0.7)', background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.22)', letterSpacing: '0.03em', height: 24, lineHeight: '24px' }}
          >
            {isTaskLoading && (!task?.titleIdentifier) && <Skeleton variant="text" width={65} />}
            {task?.titleIdentifier}
          </div>

          {!isTaskLoading && (
            <button
              className='flex items-center gap-1.5 px-2 rounded-md text-[12px] font-semibold transition-all'
              style={isComplete
                ? { color: '#059669', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', height: 24 }
                : { color: 'rgba(99,102,241,0.7)', background: 'rgba(99,102,241,0.07)', border: '1px solid rgba(99,102,241,0.2)', height: 24 }
              }
              onMouseEnter={e => {
                if (!isComplete) { e.currentTarget.style.background = 'rgba(99,102,241,0.13)'; e.currentTarget.style.color = '#4f46e5'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.35)'; }
              }}
              onMouseLeave={e => {
                if (!isComplete) { e.currentTarget.style.background = 'rgba(99,102,241,0.07)'; e.currentTarget.style.color = 'rgba(99,102,241,0.7)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.2)'; }
              }}
              onClick={() => {
                const payload = { _id: task?._id, isCompleted: !isComplete };
                if (collaboratorsIds?.length > 0) payload.collaborators = collaboratorsIds;
                dispatch(editTaskAction(payload, null));
              }}
            >
              <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor" className="shrink-0">
                <path d="m2.457 8.516.969-.99 2.516 2.481 5.324-5.304.985.989-6.309 6.284z" />
              </svg>
              <span className="mark-as-button">
                {!isComplete
                  ? <FormattedMessage id="MARK_COMPLETE" defaultMessage="Mark Complete" />
                  : <FormattedMessage id="COMPLETED" defaultMessage="Completed" />
                }
              </span>
            </button>
          )}
        </div>
        <div className='d-flex align-center' style={{ position: 'relative' }}>
          {!isTaskLoading && (
            <>
              <Tooltip title={intl.formatMessage({ id: 'COPY_TASK_LINK', defaultMessage: 'Copy Task Link' })}>
                <>
                  <Icon
                    name='copy.svg'
                    height='20px'
                    className='mx-2 hover:opacity-60'
                    onClick={() => {
                      navigator.clipboard.writeText(`${process.env.REACT_APP_URL_PREFIXED || process.env.REACT_APP_URL}/${workspaceId?.toString()}?selectedTask=${task?.titleIdentifier}`);
                      notification.success({
                        message: intl.formatMessage({ id: 'LINK_COPIED', defaultMessage: 'Link copied to clipboard' }),
                        placement: 'bottomRight',
                      });
                    }}
                  />
                </>
              </Tooltip>
              <Tooltip title={intl.formatMessage({ id: 'ATTACH_FILE', defaultMessage: 'Attach File' })}>
                <>
                  <Icon
                    name='ticket-pin.svg'
                    height='20px'
                    className='mx-2 mr-4 hover:opacity-60'
                    onClick={() => document.getElementById('file-input')?.click()}
                  />
                </>
              </Tooltip>
              <div className='mr-5'>
                {!isModal ? <Dropdown
                  menu={{
                    items,
                    style: { padding: '4px', borderRadius: 12, minWidth: 200 },
                  }}
                  overlayStyle={{ boxShadow: '0 8px 24px rgba(99,102,241,0.13)', border: '1px solid rgba(99,102,241,0.13)', borderRadius: 12 }}
                  placement='bottomRight'
                  trigger={['click']}
                >
                  <Tooltip title={intl.formatMessage({ id: 'MORE_OPTIONS', defaultMessage: 'More options' })}>
                    <img
                      className='hover:opacity-60'
                      src={'/images/icons/threeDots.svg'}
                      style={{
                        cursor: 'pointer',
                        height: '16px',
                        width: '16px',
                      }}
                      alt='icon'
                    />
                  </Tooltip>
                </Dropdown> :
                  <div className='flex align-center'>
                    {/* <Tooltip title={intl.formatMessage({ id: 'ADD_SUBTASK', defaultMessage: 'Add Subtask' })}>
                      <>
                        <Icon
                          className={'hover:opacity-60'}
                          onClick={() => setSelectedTab('3')}
                          name='share.svg'
                          height='16px'
                          pr='13px'
                        />
                      </>
                    </Tooltip> */}
                    <Tooltip title={intl.formatMessage({ id: 'MOVE_TO_SIDEVIEW', defaultMessage: 'Move to sideview' })}>
                      <>
                        <Icon
                          className={'hover:opacity-60'}
                          onClick={() => {
                            dispatch(showTaskAsModal(!isModal));
                            setIsModalView(!isModal);
                          }}
                          name='double-arrow.svg'
                          height='16px'
                          pr='16px'
                        />
                      </>
                    </Tooltip>
                    {hasTaskDeleteRights && <Tooltip title={intl.formatMessage({ id: 'DELETE_TASK', defaultMessage: 'Delete Task' })}>
                      <>
                        <Icon
                          className={'hover:opacity-60'}
                          name='delete-red.svg'
                          onClick={() => setDeleteModalOpen(true)}
                          height='24px'
                          pr='5px'
                        />
                      </>
                    </Tooltip>}
                  </div>}
              </div>
            </>
          )}
          <Tooltip title={intl.formatMessage({ id: 'CLOSE', defaultMessage: 'Close' })} className='mr-1'>
            <>
              <Icon
                className={'hover:opacity-60'}
                name='close.svg'
                height='14px'
                onClick={() => {
                  closeTicket();
                }}
              />
            </>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const task = getOpenedTask(state);
  const taskProjectIdList = getTaskProjectIdListSelector(state, {
    taskId: task?._id,
  });
  return {
    task,
    isTaskLoading: isOpenedTaskLoading(state),
    hasDeleteTaskRightsBasedOnRole: isEmpty(taskProjectIdList)
      ? false
      : taskProjectIdList?.some((projectId) =>
          hasDeleteTaskRightsBasedOnRoleSelector(state, { projectId }),
        ),
    isTaskCreator: isTaskCreator(state, { taskId: task?._id }),
    isWorkspaceOwnerAdmin: isCurrentWorkspaceOwnerOrAdmin(state),
    isWorkfloSuperAdmin: isWorkfloSuperAdminSelector(state),
  };
};

export default connect(mapStateToProps)(TaskNavSection);